import * as yup from 'yup';

import { DELETE_ACCOUNT } from 'src/features/admin/manage-users/manage-users.constants';

export const deleteUserFormValidation = yup.object({
  password: yup.string().required(),
  validation: yup
    .string()
    .test('validation', 'Type DELETE ACCOUNT here', (value) => value === DELETE_ACCOUNT)
    .required(),
});

export type DeleteUserFormValues = yup.InferType<typeof deleteUserFormValidation>;

export const DEFAULT_INPUT_VALUES: DeleteUserFormValues = {
  password: '',
  validation: '',
};
